const MOTIVOS_COLABORADORES = [
  "Atestado médico",
  "Consulta médica / odontológica",
  "Internação hospitalar",
  "Doença de familiar",
  "Óbito de familiar",
  "Licença maternidade / paternidade",
  "Licença nojo / luto",
  "Casamento",
  "Serviço militar ou convocação judicial",
  "Representação sindical",
  "Capacitação / treinamento autorizado",
  "Problema de transporte / acesso",
  "Calamidade pública",
  "Outros",
];

export default MOTIVOS_COLABORADORES;
